import { render, staticRenderFns } from "./StepServicesComponent.vue?vue&type=template&id=509047a1&scoped=true&"
import script from "./StepServicesComponent.vue?vue&type=script&lang=js&"
export * from "./StepServicesComponent.vue?vue&type=script&lang=js&"
import style0 from "./StepServicesComponent.vue?vue&type=style&index=0&id=509047a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509047a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VCombobox,VContainer,VRow})
